/**
 * Lovéane – bannière de consentement aux cookies (RGPD / CNIL).
 *
 * Utilise l'API officielle "Customer Privacy" de Shopify
 * (window.Shopify.customerPrivacy) : la même API que la bannière native
 * de Shopify utilise en interne.
 *
 * Important : `shouldShowBanner()` indique seulement si la région du
 * visiteur exige un consentement (ex. France => oui) — elle ne tient PAS
 * compte du fait qu'il ait déjà répondu ou non (c'est explicitement précisé
 * dans la documentation Shopify). Il faut donc croiser ce signal avec
 * `currentVisitorConsent()` : si aucune des catégories n'a encore de valeur
 * (chaînes vides), le visiteur n'a jamais répondu et on affiche la bannière ;
 * sinon (yes/no déjà enregistré), on ne la réaffiche pas à chaque visite.
 */
(function () {
  function initCookieBanner() {
    var privacyApi = window.Shopify && window.Shopify.customerPrivacy;
    var banner = document.getElementById('loveane-cookie-banner');
    if (!privacyApi || !banner) return;

    var acceptBtn = document.getElementById('loveane-cookie-accept');
    var refuseBtn = document.getElementById('loveane-cookie-refuse');

    function showBanner() {
      banner.hidden = false;
      banner.setAttribute('aria-hidden', 'false');
      // Let the browser paint the hidden state first so the CSS transition runs.
      window.requestAnimationFrame(function () {
        banner.classList.add('is-visible');
      });
    }

    function hideBanner() {
      banner.classList.remove('is-visible');
      banner.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () {
        banner.hidden = true;
      }, 300);
    }

    function setConsent(accepted) {
      privacyApi.setTrackingConsent(
        {
          marketing: accepted,
          analytics: accepted,
          preferences: accepted,
        },
        hideBanner
      );
    }

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        setConsent(true);
      });
    }

    if (refuseBtn) {
      refuseBtn.addEventListener('click', function () {
        setConsent(false);
      });
    }

    function visitorHasAlreadyDecided() {
      var consent = privacyApi.currentVisitorConsent && privacyApi.currentVisitorConsent();
      if (!consent) return false;
      return consent.marketing !== '' || consent.analytics !== '' || consent.preferences !== '';
    }

    if (privacyApi.shouldShowBanner() && !visitorHasAlreadyDecided()) {
      showBanner();
    }
  }

  function loadAndInit() {
    if (!window.Shopify) return;

    if (window.Shopify.customerPrivacy) {
      initCookieBanner();
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      function (error) {
        if (error) return;
        initCookieBanner();
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAndInit);
  } else {
    loadAndInit();
  }
})();
